export default function TargetMosaic() {
    return (
        <svg width="100%" height="100%" viewBox="0 0 1000 1000" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_2413_1782)">
                <rect width="100%" height="100%" fill="#FFC525" />
                <path d="M500 1000C776.142 1000 1000 776.142 1000 500C1000 223.858 776.142 0 500 0C223.858 0 0 223.858 0 500C0 776.142 223.858 1000 500 1000Z" fill="#01B4EE" />
                <path d="M500.001 175.427C320.734 175.427 175.414 320.747 175.414 500.014C175.414 679.28 320.734 824.6 500.001 824.6C679.267 824.6 824.587 679.28 824.587 500.014C824.587 320.747 679.267 175.427 500.001 175.427ZM500.001 661.694C410.694 661.694 338.307 589.294 338.307 500C338.307 410.707 410.707 338.307 500.001 338.307C589.294 338.307 661.694 410.707 661.694 500C661.694 589.294 589.294 661.694 500.001 661.694Z" fill="#FFC525" />
            </g>
            <defs>
                <clipPath id="clip0_2413_1782">
                    <rect width="100%" height="100%" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}